<template>
  <div class="pointer">
    <HoverShowContent>
      <div style="display: inline" @click="$emit('trigger-edit')">
        <i class="fa fa-file-text-o" />
        <strong class="m-l-5 m-r-10">{{ expense.vendor }}:</strong>
        {{ expense.description ? expense.description.substring(0, 30) : '' }}
        <em>({{ expense.currency }} {{ (expense.amount / 100).toFixed(2) }})</em>
        <i v-if="expense.files.length > 0" class="fa fa-paperclip m-l-10" aria-hidden="true" />
        <span class="c-gray m-l-15">
          {{ formatDate(expense.expenseAt) }}
        </span>
        <small v-if="showFileAttachmentWarning" class="c-orange faded m-l-5">
          * {{ $t('Missing file attachment') }}
        </small>
      </div>
      <template #hover-content>
        <span class="m-l-10 f-12 c-gray" @click="$emit('trigger-edit')">
          <i class="fa fa-pencil" :class="{ 'fa-pencil': editable, 'fa-eye': !editable }" />
        </span>
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <provide-state-triggered-by-slot-props
          v-if="editable"
          v-slot="{ isOn: deleteMode, turnOn: triggerDeleteMode, turnOff: cancelDeleteMode }"
        >
          <div class="inline">
            <span
              v-tooltip:top="$t('Delete expense and associated files')"
              class="m-l-5 f-12 c-gray"
              @click="triggerDeleteMode"
            >
              <i class="fa fa-trash" />
            </span>
            <ModalConfirmSwal
              v-if="deleteMode"
              :header-text="$t('Are you sure?')"
              :text="$t('Do you really want to delete the expense and associated files?')"
              :confirm-button-text="$t('Yes, delete')"
              :processing-text="$t('Deleting')"
              @confirmed="deleteExpense"
              @cancelled="cancelDeleteMode"
            />
          </div>
        </provide-state-triggered-by-slot-props>
      </template>
    </HoverShowContent>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ModalConfirmSwal from '@/components/ModalConfirmSwal.vue'
import { EXPENSE_REPORT_MUTATIONS } from '@/state/mutation-types'
import FormatDateMixin from '@/mixins/MethodFormatDateMixin'
import HoverShowContent from '@/components/HoverShowContent.vue'

export default {
  components: { HoverShowContent, ModalConfirmSwal },
  mixins: [FormatDateMixin],
  props: {
    expense: { type: Object, default: () => {} },
    // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
    editable: { type: Boolean, default: true },
    filesRequired: { type: Boolean, default: false },
    expenseReportId: { type: Number, default: 0 },
  },
  computed: {
    showFileAttachmentWarning() {
      return this.editable && this.filesRequired && this.expense.files.length < 1
    },
  },
  methods: {
    deleteExpense() {
      this.$apollo
        .mutate({
          fetchPolicy: 'no-cache',
          mutation: gql`
            mutation ($expenseId: Int!) {
              deleteExpense(localId: $expenseId) {
                globalId
                localId
              }
            }
          `,
          variables: { expenseId: this.expense.localId },
        })
        .then(() => {
          this.$store.commit(EXPENSE_REPORT_MUTATIONS.DELETE_LINE_ITEM, {
            reportId: this.expenseReportId,
            lineItemId: this.expense.localId,
          })
        })
    },
  },
}
</script>

<style scoped></style>
